import { render, staticRenderFns } from "./RoomForm.vue?vue&type=template&id=01781d3a&"
import script from "./RoomForm.vue?vue&type=script&lang=ts&"
export * from "./RoomForm.vue?vue&type=script&lang=ts&"
import style0 from "./RoomForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports